import { useEffect, useState, useCallback } from 'react'
import { useSetAtom } from 'jotai'
import { isLoadingAtom } from '@/store/loading'
import { GET } from '@/api/api'

export const useFetch = <T>(url?: string | null) => {
  const [data, setData] = useState<T | null>(null)
  const [error, setError] = useState<Error | null>(null)
  const [reloadKey, setReloadKey] = useState(0)
  const setGlobalLoading = useSetAtom(isLoadingAtom)

  const refetch = useCallback(() => {
    setReloadKey((prev) => prev + 1)
  }, [])

  useEffect(() => {
    if (!url) {
      setData(null)
      setError(null)
      return
    }

    const fetchData = async () => {
      setGlobalLoading(true)

      await GET(url)
        .then((response: any) => {
          setData(response.data)
          setError(null)
        })
        .catch((err: Error) => {
          setError(err)
        })
        .finally(() => {
          setGlobalLoading(false)
        })
    }

    fetchData()
  }, [reloadKey])

  return { data, error, refetch }
}
